<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>

    <div>
      <div>
        <div class="row">
          <div class="col-md-4">
            <base-button type="primary" @click.prevent="onNew" icon>
              <span class="btn-inner--icon">
                <i class="ni e-add"></i>
              </span>New lesson
            </base-button>
            <base-button type="info" @click.prevent="onRefresh" icon>
              <span class="btn-inner--icon">
                <i class="ni refresh-02"></i>
              </span>Refresh
            </base-button>
          </div>
          <div class="col-md-4">
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-md-4">
            <base-input v-model="searchQuery" prepend-icon="fas fa-search" placeholder="Search..."></base-input>
          </div>
        </div>
        <el-table
          :data="queriedData"
          row-key="id"
          header-row-class-name="thead-light"
          @sort-change="sortChange"
        >
          <el-table-column min-width="620px">
            <template v-slot="{row}">
              <div class="d-flex justify-content-center"></div>
              <lesson-item
                :notes="row.notes"
                :stage="row.stagename"
                :description="row.description"
                :title="row.title"
                :orderindex="row.orderindex"
                :duration="row.duration"
              ></lesson-item>
            </template>
          </el-table-column>
          <el-table-column min-width="150px" align="right" label="Actions">
            <div slot-scope="{$index, row}" class="d-flex">
              <base-button
                @click.native="onEdit($index, row)"
                class="edit"
                type="warning"
                size="sm"
                icon
              >
                <i class="text-white ni n-edit"></i>
              </base-button>
              <base-button
                @click.native="onTask(row)"
                class="remove btn-link"
                type="info"
                size="sm"
                icon
              >
                <i class="text-white ni todo"></i>
              </base-button>
              <base-button
                @click.native="onDelete(row)"
                class="remove btn-link"
                type="danger"
                size="sm"
                icon
              >
                <i class="text-white ni e-remove"></i>
              </base-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class>
          <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
        </div>
        <base-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        ></base-pagination>
      </div>
    </div>

    <modal :show.sync="modalform" size="lg">
      <h6 slot="header" class="modal-title">Lesson action</h6>
      <validation-observer ref="formvalid">
        <div class="row">
          <div class="col-lg-6">
            <base-input label="Stage" :rules="{'required': mode === 'Create'}" name="stage">
              <span v-if="mode === 'Edit'">{{lesson.stagename}}</span>
              <el-select
                v-if="mode === 'Create'"
                class="select-primary pagination-select"
                v-model="lesson.stageId"
                placeholder="Stage"
              >
                <el-option
                  class="select-primary"
                  v-for="item in stages"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              name="title"
              rules="required"
              v-model="lesson.title"
              class="mb-3"
              label="Title"
              placeholder="Title"
            ></base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <base-input label="Description">
              <textarea class="form-control" rows="3" resize="none" v-model="lesson.description"></textarea>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2">
            <base-input label="Duration">
              <el-select
                class="select-primary pagination-select"
                v-model="lesson.duration"
                placeholder="Dur"
              >
                <el-option class="select-primary" :key="30" :label="'30 min'" :value="30"></el-option>
                <el-option class="select-primary" :key="45" :label="'45 min'" :value="45"></el-option>
                <el-option class="select-primary" :key="60" :label="'60 min'" :value="60"></el-option>
                <el-option class="select-primary" :key="90" :label="'90 min'" :value="90"></el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-10">
            <base-input label="Notes" v-model="lesson.notes"></base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input
              v-model="lesson.orderindex"
              type="number"
              placeholder="Order"
              label="Order index"
              max="100"
              min="0"
            ></base-input>
          </div>
        </div>
      </validation-observer>
      <div class="text-center">
        <base-button type="primary" @click.prevent="onSaveLesson">Save changes</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "@/components";
import lessonTableMixin from "./lessonTableMixin";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { LessonType } from "../../../services/types";
import LessonItem from "./LessonItem";
export default {
  mixins: [lessonTableMixin],
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Loading,
    LessonItem,
  },
  computed: {
    mode() {
      return this.lesson.id ? "Edit" : "Create";
    },
  },
  props: {
    courseId: String,
  },
  data() {
    return {
      tableData: [],
      isLoading: false,
      stageId: "",
      modalform: false,
      lesson: {},
      stages: [],
    };
  },
  methods: {
    onNew() {
      this.loadStages();
      this.lesson = new LessonType();
      this.lesson.duration = 30;
      this.modalform = true;
    },
    onEdit(index, row) {
      this.lesson = Object.assign({}, row);
      this.modalform = true;
    },
    onTask(id) {
      this.$emit("taskClicked", id);
    },
    onDelete(row) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteLesson(row.id);
          }
        });
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
